import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import AppConfigurationForm from "../../component/admin/appConfigurationForm/AppConfigurationForm";
import {
  getAppConfiguration,
  saveAppConfiguration,
} from "../../api/appConfiguration";

export default function Goals() {
  const token = useSelector((state) => state.auth.token);
  const [initialValues, setInitialValues] = useState({
    android_version: "",
    forcefully_update_android: false,
    ios_version: "",
    forcefully_update_ios: false,
    default_leaderboard: "monthly",
    guest_football_votes_enabled: true,
    guest_pageant_votes_enabled: true,
  });
  const [loding, setLoading] = useState(false);

  const fetchAppConfiguration = async (token) => {
    try {
      const data = await getAppConfiguration(token);
      if (data.success) {
        toast.success("App configuration fetched successfully !!");
        setInitialValues({
          android_version: data.data.android_version || "",
          forcefully_update_android:
            data.data.forcefully_update_android || false,
          ios_version: data.data.ios_version || "",
          forcefully_update_ios: data.data.forcefully_update_ios || false,
          default_leaderboard:
            data.data.default_leaderboard || "monthly",
          guest_football_votes_enabled:
            data.data.guest_football_votes_enabled !== false,
          guest_pageant_votes_enabled:
            data.data.guest_pageant_votes_enabled !== false,
        });
      } else {
        toast.error("Failed to fetch app configuration !!");
      }
    } catch (e) {
      toast.error("No app configuration found !!");
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,

    validationSchema: Yup.object().shape({
      android_version: Yup.string().required("Please enter Android version"),

      forcefully_update_android: Yup.boolean(),

      ios_version: Yup.string().required("Please enter iOS version"),

      forcefully_update_ios: Yup.boolean(),
      default_leaderboard: Yup.string().required(),
      guest_football_votes_enabled: Yup.boolean(),
      guest_pageant_votes_enabled: Yup.boolean(),
    }),

    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);
        console.log("Submitting app configuration:", values);

        const response = await saveAppConfiguration(token, values);
        if (response.success) {
          toast.success("App configuration saved successfully !!");
          resetForm({ values });
        } else {
          toast.error("Failed to save app configuration !!");

          resetForm();
        }
        // API call here
      } catch (e) {
        toast.error("Error !!");
      } finally {
        setLoading(false);
      }
    },
  });

  useEffect(() => {
    fetchAppConfiguration(token);
    /// call api to get app versions
  }, [token]);

  return (
    <React.Fragment>
      <ToastContainer />
      <Box className="">
        <Box className="page_title">
          <Typography variant="h1" component="h1">
            App Configuration
          </Typography>
        </Box>
        <Box className="page_inner">
          <AppConfigurationForm formik={formik} loading={loding} />
        </Box>
      </Box>
    </React.Fragment>
  );
}
